<template>
    <div>
      <div class="row">
        <div class="col-md-3">
            <stats-card :type="'primary'" icon="fa fa-users" :small-title="'Total Voters'" :title="total_voters">
                  <div class="stats" slot="footer">
                    <i :class="'fa fa-external-link'"></i>
                    View more
                  </div>
                </stats-card>
        </div>
        <div class="col-md-3">
            <stats-card :type="'warning'" icon="fa fa-check" :small-title="'Verified'" :title="total_validated">
                  <div class="stats" slot="footer">
                    <i :class="'fa fa-external-link'"></i>
                    View more
                  </div>
                </stats-card>
        </div>
        <div class="col-md-3">
            <stats-card :type="'info'" icon="fa fa-map-pin" :small-title="'Voter Turnout'" :title="total_voted">
                  <div class="stats" slot="footer">
                    <i :class="'fa fa-external-link'"></i>
                    View more
                  </div>
                </stats-card>
        </div>
        <div class="col-md-3">
            <stats-card :type="'danger'" icon="fa fa-users" :small-title="'Voted Straight'" :title="total_voted_straight">
                  <div class="stats" slot="footer">
                    <i :class="'fa fa-external-link'"></i>
                    View more
                  </div>
                </stats-card>
        </div>
        <div class="col-md-12"></div>
        <div class="col-md-12"  v-for="barangay_data,i in grouped_barangay_data" :key="i">
            <barangay-voters-chart :collection="barangay_data"></barangay-voters-chart>
        </div>
        <div class="col-md-12">
            <barangay-voters-voted-chart :collection="barangay_voters"></barangay-voters-voted-chart>
        </div>
      </div>
    </div>
  </template>
  
  <script>

  import firebase from 'firebase/app'

  import StatsCard from "../../../UIComponents/Cards/StatsCard.vue"
  import { Analytic } from '@/resources/analytics'
  import BarangayVotersChart from './BarangayVotersChart.vue'
  import BarangayVotersVotedChart from './BarangayVotersVotedChart.vue'
  import { db } from '@/firebase'
  import { User } from '@/resources/user'

  export default {
    components: {
      StatsCard,
        BarangayVotersChart,
        BarangayVotersVotedChart,
    },
    data() {
      return {
        user: null,
        loading: false,
        total_voters: 0,
        total_voted: 0,
        total_voted_straight: 0,
        total_validated: 0,
        barangay_voters: [],
        grouped_barangay_data: []
      }
    },
    created: function () {
      this.user = this.$store.state.user
      this.getNotifications()
      this.getOverAllSummary()
      this.getSummary()
    },
    methods: {
        getOverAllSummary() {
            let params = {}
            this.loading = true
            Analytic.getOverAllSummary(params)
                .then(result => {
                  this.total_voters = result.data.total_voters
                  this.total_validated = result.data.total_validated
                  this.total_voted = result.data.total_voted
                  this.total_voted_straight = result.data.total_voted_straight
            })
            .catch(() => {

            }).finally(() => {
            this.loading = false
            })
        },
        getSummary() {
            let params = {}
            this.loading = true
            this.barangay_voters = []
            Analytic.getSummary(params)
                .then(result => {
                  this.grouped_barangay_data = result.data.grouped_data
                  this.barangay_voters = result.data.data.barangay_voters
            })
            .catch(() => {

            }).finally(() => {
            this.loading = false
            })
        },
        getNotifications() {
          let path = 'notifications/dashboard'

          var ref = db.ref(path)
      
          ref
          .orderByChild('timestamp')
          .limitToLast(1) // Limit to the last record (the latest added)
          .on("child_added", (snapshot) => {
            const notification = snapshot.val();
            var notificationDate = new Date(notification.timestamp * 1000)
            var currentDate = new Date()
            const differenceSec = Math.abs(currentDate - notificationDate) / 1000;
            console.log("Dashboard notification")
            if (differenceSec < 3) {
              this.getOverAllSummary()
              this.getSummary()
            }
          });
        },
    }
  }
  </script>
  
  <style></style>
  